import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import BuyerPortalLayout from '../../components/buyer/BuyerPortalLayout';
import { fetchBuyerRfqs } from '../../lib/buyerApi';

const BuyerRfqsPage: React.FC = () => {
  const [rfqs, setRfqs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params: Record<string, any> = {};
      if (statusFilter) params.status = statusFilter;
      const res = await fetchBuyerRfqs(params);
      setRfqs(res.items || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, [statusFilter]);

  useEffect(() => { load(); }, [load]);

  return (
    <BuyerPortalLayout title="My RFQs">
      <div className="flex items-center justify-between mb-4">
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}
          className="px-4 py-2.5 bg-white border border-gray-200 rounded-xl text-sm">
          <option value="">All Status</option>
          <option value="draft">Draft</option><option value="published">Published</option>
          <option value="quotation_open">Quotation Open</option><option value="evaluation">Evaluation</option>
          <option value="awarded">Awarded</option><option value="closed">Closed</option>
        </select>
        <Link to="/account/rfqs/new" className="px-5 py-2.5 bg-emerald-600 text-white text-sm font-bold rounded-xl hover:bg-emerald-700 transition">
          + Create RFQ
        </Link>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-16"><div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" /></div>
      ) : rfqs.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-2xl border border-gray-100">
          <p className="text-5xl mb-4">📋</p>
          <h3 className="text-lg font-bold text-gray-900 mb-2">No RFQs yet</h3>
          <p className="text-gray-500 text-sm mb-4">Create a Request for Quotation to start procuring.</p>
          <Link to="/account/rfqs/new" className="inline-flex px-6 py-3 bg-emerald-600 text-white rounded-xl font-bold text-sm hover:bg-emerald-700 transition">Create RFQ</Link>
        </div>
      ) : (
        <div className="bg-white border border-gray-100 rounded-2xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-100">
              <tr>
                <th className="px-5 py-3 text-left font-bold text-gray-500 text-xs uppercase">RFQ</th>
                <th className="px-5 py-3 text-left font-bold text-gray-500 text-xs uppercase">Title</th>
                <th className="px-5 py-3 text-left font-bold text-gray-500 text-xs uppercase">Visibility</th>
                <th className="px-5 py-3 text-left font-bold text-gray-500 text-xs uppercase">Deadline</th>
                <th className="px-5 py-3 text-left font-bold text-gray-500 text-xs uppercase">Status</th>
                <th className="px-5 py-3 text-left font-bold text-gray-500 text-xs uppercase">Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {rfqs.map((rfq: any) => (
                <tr key={rfq.id} className="hover:bg-gray-50 transition cursor-pointer" onClick={() => window.location.href = `/account/rfqs/${rfq.id}`}>
                  <td className="px-5 py-3 font-mono text-xs font-medium">{rfq.rfq_number}</td>
                  <td className="px-5 py-3 font-bold text-gray-900">{rfq.title}</td>
                  <td className="px-5 py-3 text-gray-500 text-xs">{(rfq.visibility || '').replace(/_/g, ' ')}</td>
                  <td className="px-5 py-3 text-gray-500 text-xs">{rfq.quote_deadline ? new Date(rfq.quote_deadline).toLocaleDateString() : '—'}</td>
                  <td className="px-5 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${
                      rfq.status === 'awarded' ? 'bg-emerald-100 text-emerald-700' :
                      rfq.status === 'published' ? 'bg-blue-100 text-blue-700' :
                      rfq.status === 'draft' ? 'bg-gray-100 text-gray-600' :
                      'bg-amber-100 text-amber-700'
                    }`}>{rfq.status}</span>
                  </td>
                  <td className="px-5 py-3 text-gray-500 text-xs">{new Date(rfq.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </BuyerPortalLayout>
  );
};

export default BuyerRfqsPage;
